import React from "react";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <>
      <div className="landingpage">
        <Outlet />
      </div>
    </>
  );
};
export default MainLayout;
